export default __webpack_public_path__ + "static/media/arrange.1c86aa8f.png";